import type { SortDirection } from '@openx/types/tableCriteria.ts';

import type { ColumnKey } from '../modules/DealLibraryList/constants.ts';

export type SearchParamsObj = {
  params: {
    phrase?: string;
    sort?: SortDirection;
    column?: ColumnKey;
    pageNumber?: string;
  };
};

export const getSearchParamsObj = (searchParams: URLSearchParams): SearchParamsObj => ({
  params: Object.fromEntries([...searchParams]),
});

export const getPath = (params?: string): string => {
  if (!params) {
    return '/';
  }

  return `/${params}`;
};
